import { render, staticRenderFns } from "./RecordTable.vue?vue&type=template&id=a65bf49e&"
import script from "./RecordTable.vue?vue&type=script&lang=js&"
export * from "./RecordTable.vue?vue&type=script&lang=js&"
import style0 from "./RecordTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports